import React, { createContext, useContext, useState, useEffect } from 'react';
import { t } from '../utils/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Get initial language from localStorage or default to 'ar'
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'ar';
  });

  // Determine direction based on language
  const direction = language === 'ar' ? 'rtl' : 'ltr';

  // Update HTML dir attribute when language changes
  useEffect(() => {
    document.documentElement.dir = direction;
    document.documentElement.lang = language;
    
    // Also set it on body for better compatibility
    document.body.setAttribute('dir', direction);
  }, [direction, language]);

  const changeLanguage = (lang) => {
    if (lang !== 'en' && lang !== 'ar') {
      console.warn('Invalid language. Supported languages: en, ar');
      return;
    }
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'ar' : 'en';
    changeLanguage(newLang);
  };

  const value = {
    language,
    direction,
    changeLanguage,
    toggleLanguage,
    isRTL: direction === 'rtl',
    isArabic: language === 'ar',
    isEnglish: language === 'en',
    t: (key) => t(key, language),
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;








